import React from 'react'

import { BodyText, HeadingXSmall } from '@pb/components'
import Sticky from 'react-stickynode'

import OPTIMIZELY from 'constants/optimizely'
import useAccountFeature from 'features/account/hooks/useAccountFeature'
import useOptimizelyToggle from 'features/account/hooks/useOptimizelyToggle'
import { HubPurchaseList } from 'features/account/purchases'
import RecentlyViewed from 'features/account/recently-viewed/index'
import { UserMenu } from 'features/account/user-menu'

export interface DesktopNonMemberProps {
  userDisplayName?: string
  userEmail?: string
}

const DesktopNonMember: React.FC<DesktopNonMemberProps> = ({ userDisplayName, userEmail }) => {
  const {
    pages: {
      hub: { shouldShowClubCard },
    },
    shouldShowFooter,
  } = useAccountFeature()
  /**
   * Only for A/B testing purposes
   * TODO: remove when iterative testing of component is completed.
   * https://hmgroup.atlassian.net/browse/CRMMA-5370
   */
  const isRecentlyViewedEnabled = useOptimizelyToggle({
    key: OPTIMIZELY.ACCOUNT_RECENTLY_VIEWED,
  })
  return (
    <>
      <Sticky bottomBoundary={shouldShowFooter ? '.site-footer-scroll-stop' : 'footer'}>
        <aside>
          {shouldShowClubCard && (
            <>
              {userDisplayName && <HeadingXSmall Tag="p">{userDisplayName}</HeadingXSmall>}
              <BodyText>{userEmail}</BodyText>
            </>
          )}
          <UserMenu />
        </aside>
      </Sticky>
      <main id="main-content">
        <HubPurchaseList />
        {isRecentlyViewedEnabled && <RecentlyViewed />}
      </main>
    </>
  )
}

export default DesktopNonMember
